var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"map",attrs:{"id":"olMap"}})
}
var staticRenderFns = []

export { render, staticRenderFns }